import { pushOutbox, readOutbox, removeFromOutbox, updateOutbox } from './db';

/**
 * Fila de escritas pendentes.
 *
 * Guarda INTENÇÃO, não linha de banco: o nome da operação e os argumentos com
 * que ela foi chamada. É por isso que a camada de dados usa nomes como
 * `updateServiceBilling` em vez de `update em services` — "faturei este
 * serviço" é reenviável; "escrevi nestas colunas" não diz o suficiente.
 *
 * Cada registro carrega o `userId` de quem lançou. O aparelho é compartilhado
 * entre técnicos, e reenviar lançamento de um sob a sessão de outro daria
 * erro de permissão na melhor das hipóteses e atribuição errada na pior.
 */

const registry = new Map();

/**
 * Registra uma operação enfileirável.
 *
 * O nome vai para o disco, então não pode mudar sem migração: um registro
 * gravado ontem precisa achar a função hoje.
 */
export const registerOp = (name, fn) => {
  if (registry.has(name)) throw new Error(`operação duplicada na fila: ${name}`);
  registry.set(name, fn);
};

export const resolveOp = (name) => registry.get(name);

export const enqueue = async (op, args, { userId = null, pendingKey = null, label = '', patch = null } = {}) => {
  if (!registry.has(op)) throw new Error(`operação não registrada: ${op}`);
  return pushOutbox({
    op, args, userId, pendingKey, label, patch,
    createdAt: Date.now(),
    attempts: 0,
    lastError: null,
  });
};

export const listPending = (userId = null) =>
  readOutbox().then(rows =>
    userId ? rows.filter(r => !r.userId || r.userId === userId) : rows);

export const countPending = (userId = null) =>
  listPending(userId).then(rows => rows.length);

export const drop = (seq) => removeFromOutbox(seq);

export const markAttempt = (record, error) =>
  updateOutbox({
    ...record,
    attempts: (record.attempts || 0) + 1,
    lastError: error ? String(error.message || error) : null,
  });
